import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apibasePath } from "../config";
const ThankYouBubble = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [brandLogo, setBrandLogo] = useState(null);

  // Fetch company and brand data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const companyResponse = await axios.get(
          `${apibasePath}/client/profiles/company/`,
          { headers: { "Content-Type": "application/json" } },
        );
        setName(companyResponse.data.name);

        const brandResponse = await axios.get(
          `${apibasePath}/client/profiles/brand/`,
          { headers: { "Content-Type": "application/json" } },
        );
        setBrandLogo(brandResponse.data.logo);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // Runs only once on mount

  // Handle back button navigation
  useEffect(() => {
    const handleBackButton = () => {
      const token = localStorage.getItem("token");

      if (token) {
        // If token exists, remove it and redirect to login
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        navigate("/", { replace: true }); // Ensure user cannot navigate back
      } else {
        // If no token, push to login page again
        navigate("/", { replace: true });
      }
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  // Navigate to homepage
  const handleBackToHome = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    navigate("/");
  };

  useEffect(() => {
    const unblock = window.history.pushState(
      null,
      null,
      window.location.pathname,
    );
    const handlePopState = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center w-100 vh-100"
      style={{
        backgroundImage: "linear-gradient(to bottom left,#C7E0E3, #FFFFFF)",
      }}
    >
      <img
        src="/images/thankyou1.jpg"
        alt="Thank You"
        className="w-50"
        style={{ height: "197px", objectFit: "contain" }}
      />

      <div className="mt-3 text-white">
        <h3 style={{ color: "black" }}>
          Your final submission was successful.
        </h3>
        <p style={{ fontSize: "20px", color: "black" }}>
          Please contact <b>{name}</b>
        </p>
        <button
          className="btn btn-light mt-3"
          style={{
            borderRadius: "15px",
            color: "white",
            backgroundColor: "#396D72",
            border: "1px solid #628573",
            fontFamily: "Roboto",
            fontWeight: "600",
            fontSize: "12px",
          }}
          onClick={handleBackToHome}
        >
          Go to Homepage
        </button>
      </div>

      {/* Powered By Section */}
      <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <h4
            align="center"
            style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
          >
            POWERED BY
          </h4>
          <div
            style={{
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "5px", //add some space between text and logo
            }}
          >
            <img
              src={brandLogo}
              alt="Brandlogo"
              style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouBubble;
